import request from '@/utils/request'; // 获取客户列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/customerOa/list',
    method: 'post',
    data: data
  });
} // 获取客户列表(xiugai)

export function fetchList1(data) {
  return request({
    url: '/pmsservice/api/syncFace/userList',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/customerOa/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/customerOa/get',
    method: 'post',
    data: data
  });
} // 详情

export function fetchGet(data) {
  return request({
    url: '/pmsservice/api/customerOa/getCompany',
    method: 'post',
    data: data
  });
}
export function fetchCustomerDetail(data) {
  return request({
    url: '/pmsservice/api/houseStatus/getCustomer',
    method: 'post',
    data: data
  });
} // 删除

export function deleteCompany(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/customerOa/deleteCompany',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/customerOa/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/customerOa/update',
    method: 'post',
    data: data
  });
} // 上报

export function customerDeclare(data) {
  return request({
    url: '/pmsservice/api/basiDeclare/customerDeclare',
    method: 'post',
    data: data
  });
} // 门禁下发同步日志

export function syncLogFindList(data) {
  return request({
    url: '/pmsservice/api/customerOa/syncLogFindList',
    method: 'post',
    data: data
  });
}